<div
	*ngIf="dataLoaded; else data_not_loaded"
	class="sdp-policy-container"
>
	<div
		*ngIf="resources.length > 0; else no_resources"
		class="policy-input"
	>
		<form
			[formGroup]="form"
			class="sdp-policy-wizard-form"
			novalidate
		>
			<div class="sdp-form-control">
				<div class="sdp-form-control-input-container">
					<mat-form-field>
						<mat-select
							placeholder="{{ 'policy.wizard.name.selector.message' | translate }}"
							formControlName="resource"
							class="sdp-application-select-type-select"
						>
							<mat-option
								*ngFor="let r of resources"
								[value]="r"
							>{{ r.name }} </mat-option>
						</mat-select>
						<mat-error *ngIf="form.controls['resource'].hasError('required')">{{ "error.message.policy.application.required" | translate }}</mat-error>
					</mat-form-field>
				</div>
			</div>
		</form>
	</div>
	<ng-template #no_resources>
		<div class="sdp-policy-no-resources-container">
			<mat-card>
				{{ "policy.no.resources" | translate }}
			</mat-card>
		</div>
	</ng-template>
</div>
<ng-template #data_not_loaded>
	<div class="sdp-policy-add-skeleton"></div>
</ng-template>